<div class="user-permission-page">
    <div class="btn-back-detail" (click)="goBack()">
        <i class="fal fa-arrow-left"></i>
        <span>Ver todos los gestores</span>
    </div>

    <!-- Loading -->
    <div class="container-lottie" *ngIf="!loaded">
        <ng-lottie [options]="{path: 'assets/lotties/loading.json'}" containerClass="loading-box-small"></ng-lottie>
    </div>

    <div class="permission-grid" *ngIf="loaded">

        <!-- Card perfil -->
        <div class="perm-card profile-card">
            <div class="profile-avatar">
                <span>{{infoUserPermission?.name?.charAt(0) | uppercase}}</span>
            </div>
            <p class="profile-name">{{infoUserPermission?.name}}</p>
            <span class="profile-badge" [class.owner-badge]="isOwner">{{isOwner ? 'Propietario' : 'Gestor'}}</span>
            <div class="profile-fields">
                <div class="field-group">
                    <label class="field-label">CUENTA</label>
                    <div class="field-input"><span>{{infoUserPermission?.email}}</span></div>
                </div>
                <div class="field-group">
                    <label class="field-label">ÚLTIMO ACCESO</label>
                    <div class="field-input"><span>{{now | date: 'dd/MM/yyyy'}}</span></div>
                </div>
            </div>
        </div>

        <!-- Card funciones -->
        <div class="perm-card functions-card">
            <div class="card-header">
                <div class="card-header-left">
                    <i class="fa-light fa-sliders card-icon"></i>
                    <h3 class="card-title">Funciones</h3>
                </div>
                <span class="card-tag">PERMISOS</span>
            </div>
            <div class="card-body">
                <p class="card-helper">Selecciona las funciones a las que tiene acceso este gestor.</p>
                <div class="functions-list">
                    <label class="function-row" *ngFor="let function of rolesFunctions"
                        [class.is-checked]="rolesUser?.includes(function.id) || rolesUser?.includes(1) || isOwner"
                        [class.is-owner]="isOwner">
                        <div class="function-info">
                            <span class="function-name">{{function.name}}</span>
                            <span class="function-desc">{{getRoleDescription(function.name)}}</span>
                        </div>
                        <mat-checkbox color="primary" *ngIf="!isOwner"
                            (change)="changeFunction(function.id, $event.checked)"
                            [checked]="rolesUser?.includes(function.id) || rolesUser?.includes(1)">
                        </mat-checkbox>
                        <i class="fa-light fa-check owner-check" *ngIf="isOwner"></i>
                    </label>
                </div>
            </div>
        </div>

        <!-- Card espacios -->
        <div class="perm-card spaces-card" *ngIf="placesBusiness?.length > 0">
            <div class="card-header">
                <div class="card-header-left">
                    <i class="fa-light fa-location-dot card-icon"></i>
                    <h3 class="card-title">Espacios</h3>
                </div>
                <span class="card-tag">ACCESO</span>
            </div>
            <div class="card-body">
                <p class="card-helper">Espacios a los que tiene acceso este gestor.</p>
                <div class="checks-grid">
                    <div *ngFor="let place of placesBusiness" class="check-item">
                        <mat-checkbox color="primary"
                            *ngIf="!isOwner && placesBusiness.length > 1"
                            (change)="changePlace(place.id, $event.checked)"
                            [checked]="placesUser?.includes(place.id)">
                            {{place.name}}
                        </mat-checkbox>
                        <span class="owner-function" *ngIf="isOwner || placesBusiness.length == 1">
                            <i class="fa-light fa-check check-icon"></i>{{place.name}}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Botón guardar cambios -->
        <div class="save-area" *ngIf="!isOwner && hasChanges" (click)="savePermission()">
            <i class="fa-light fa-floppy-disk"></i>
            <span>Guardar cambios</span>
        </div>

    </div>

    <!-- Acciones footer -->
    <div class="footer-actions" *ngIf="loaded">
        <div class="delete-btn" (click)="deleteGestor()" *ngIf="admin && !isOwner">
            <i class="fa-light fa-trash"></i>
            <span>Eliminar gestor</span>
        </div>
    </div>
</div>

